
const valueFormat = (value, decimal = 2) => {
    const newValue = parseFloat(value);
    if (isNaN(newValue)) return '-';
    return parseFloat(newValue.toFixed(decimal));
};

export {
    valueFormat,
};